// 순수(비-React) 모듈이므로 vanilla 엔트리 사용 (top-level 'jotai'는 react 바인딩을 끌어옴).
import { getDefaultStore } from 'jotai/vanilla';
import {
  laboratorySettingAtomFamily,
  LABORATORY_DEFAULT_VALUES,
} from '../hooks/useLaboratorySetting/laboratorySetting.atom';

/**
 * 실험실 `IS_GIF_IMAGE` 플래그의 현재값.
 *
 * - FilterList 등 별도 jotai store 하위에서도 동일하게 읽도록 default store에서 직접 조회한다.
 * - 부팅 시 App 루트의 `useLaboratorySetting('IS_GIF_IMAGE')`가 native 저장소에서 하이드레이션한다.
 *   하이드레이션 전(atom 미설정)에는 기본값(true)을 반환한다.
 * - 비반응형 조회이므로 실험실에서 토글한 값은 카드가 리렌더되는 시점에 반영된다.
 */
export const isGifImageEnabled = (): boolean =>
  getDefaultStore().get(laboratorySettingAtomFamily('IS_GIF_IMAGE')) ??
  LABORATORY_DEFAULT_VALUES.IS_GIF_IMAGE;

/**
 * 상품 카드 썸네일의 GIF/애니 재생 여부.
 *
 * 서버 `use_animation`(상품별 애니 이미지 여부)과 실험실 `IS_GIF_IMAGE` 플래그를
 * 모두 만족할 때만 재생한다. 상품 카드가 아닌 공통 이미지에는 적용하지 않는다.
 */
export const resolveGoodsCardDoAnimate = (
  useAnimation: boolean | undefined,
): boolean => Boolean(useAnimation) && isGifImageEnabled();
